import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProjectTaskService {
  constructor(private api: ApiService) {}

  // -------------------------------------------------------------------------
  // Project Tasks
  // -------------------------------------------------------------------------
  getAllProjectTasks(data: any): Observable<any> {
    return this.api.post(environment.getAllProjectTasks, data);
  }
  createProjectTask(data: any): Observable<any> {
    return this.api.post(environment.createProjectTask, data);
  }
  updateProjectTask(data: any): Observable<any> {
    return this.api.post(environment.updateProjectTask, data);
  }
  deleteProjectTask(data: any): Observable<any> {
    return this.api.post(environment.deleteProjectTask, data);
  }
  getProjectTaskById(data: any): Observable<any> {
    return this.api.post(environment.getProjectTaskById, data);
  }
  updateProjectTaskStatus(data: any): Observable<any> {
    return this.api.post(environment.updateProjectTaskStatus, data);
  }

  // -------------------------------------------------------------------------
  // Project Task Items
  // -------------------------------------------------------------------------
  createTaskItem(data: any): Observable<any> {
    return this.api.post(environment.createTaskItem, data);
  }
  updateTaskItem(data: any): Observable<any> {
    return this.api.post(environment.updateTaskItem, data);
  }
  getAllTaskItems(data: any): Observable<any> {
    return this.api.post(environment.getAllTaskItems, data);
  }
  getTaskItemById(data: any): Observable<any> {
    return this.api.post(environment.getTaskItemById, data);
  }
  deleteTaskItem(data: any): Observable<any> {
    return this.api.post(environment.deleteTaskItem, data);
  }
  updateTaskItemStatus(data: any): Observable<any> {
    return this.api.post(environment.updateTaskItemStatus, data);
  }

  // -------------------------------------------------------------------------
  // Project Task Comments
  // -------------------------------------------------------------------------
  createTaskComment(data: any): Observable<any> {
    return this.api.post(environment.createTaskComment, data);
  }
  updateTaskComment(data: any): Observable<any> {
    return this.api.post(environment.updateTaskComment, data);
  }
  getAllTaskComments(data: any): Observable<any> {
    return this.api.post(environment.getAllTaskComments, data);
  }
  getTaskCommentById(data: any): Observable<any> {
    return this.api.post(environment.getTaskCommentById, data);
  }
  deleteTaskComment(data: any): Observable<any> {
    return this.api.post(environment.deleteTaskComment, data);
  }

  // -------------------------------------------------------------------------
  // Project Task Time Logs
  // -------------------------------------------------------------------------
  createTaskTimeLog(data: any): Observable<any> {
    return this.api.post(environment.createTaskTimeLog, data);
  }
  updateTaskTimeLog(data: any): Observable<any> {
    return this.api.post(environment.updateTaskTimeLog, data);
  }
  getAllTaskTimeLogs(data: any): Observable<any> {
    return this.api.post(environment.getAllTaskTimeLogs, data);
  }
  getTaskTimeLogById(data: any): Observable<any> {
    return this.api.post(environment.getTaskTimeLogById, data);
  }
  deleteTaskTimeLog(data: any): Observable<any> {
    return this.api.post(environment.deleteTaskTimeLog, data);
  }

  // -------------------------------------------------------------------------
  // Project Task Activity
  // -------------------------------------------------------------------------
  getTaskActivities(data: any): Observable<any> {
    return this.api.post(environment.getTaskActivities, data);
  }
}

